import { cva, type VariantProps } from "class-variance-authority";
import { createElement, forwardRef, type HTMLAttributes } from "react";

import { cn } from "../utils";

const textVariants = cva("last:mb-0", {
  variants: {
    htmlTag: {
      div: "",
      span: "",
      p: "m-0",
      dl: "",
      dt: "",
      dd: "",
      label: "",
    },
  },
});

export interface ITextProps
  extends HTMLAttributes<HTMLElement>,
    VariantProps<typeof textVariants> {
  htmlFor?: string;
}

export const Text = forwardRef<HTMLElement, ITextProps>(
  ({ children, className, htmlTag = "div", ...rest }, ref) => {
    return createElement(
      htmlTag ?? "div",
      {
        className: cn(textVariants({ htmlTag }), className),
        ref,
        ...rest,
      },
      children,
    );
  },
);
